var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBringBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#2D6CE6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 6.542v-.029c-.008-.552-.226-1.071-.617-1.463-.398-.398-.927-.618-1.49-.618H8.985c-.288-1.248-1.406-2.18-2.738-2.181l-1.92-.001c-1.549 0-2.81 1.262-2.81 2.814v7.872c0 1.552 1.261 2.814 2.81 2.814h3.41c.388 0 .703-.315.703-.704 0-.388-.315-.703-.703-.703h-3.41c-.774 0-1.405-.631-1.405-1.407V5.064c.001-.776.631-1.407 1.405-1.407h1.92c.774.001 1.404.632 1.404 1.408v.07c0 .39.315.704.703.704h6.039c.187 0 .364.073.496.206.128.128.2.296.206.475v.118c0 .362.293.655.655.655.414 0 .75-.336.75-.75v-.001z",
    transform: "translate(-1210.000000, -345.000000) translate(1041.000000, 0.000000) translate(160.000000, 336.000000) translate(9.000000, 9.000000)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2D6CE6",
    strokeWidth: 0.5,
    d: "M9.347 12.352c.192 0 .347.157.347.351 0 1.706 1.371 3.094 3.056 3.094.513 0 1.02-.131 1.466-.379.168-.093.38-.03.471.14.092.17.03.384-.137.477-.549.304-1.171.465-1.8.465-1.002 0-1.943-.395-2.652-1.112C9.39 14.67 9 13.718 9 12.703c0-.194.155-.351.347-.351zm2.427-4.748c.135-.138.355-.139.491-.002.125.125.136.322.033.46l-.03.037-.79.807h1.272c1.002 0 1.943.395 2.652 1.112.708.717 1.098 1.67 1.098 2.685 0 .656-.168 1.303-.486 1.87-.064.115-.181.18-.302.18-.058 0-.117-.016-.171-.047-.167-.096-.226-.31-.131-.479.259-.462.396-.99.396-1.524 0-1.674-1.32-3.042-2.963-3.092l-.093-.002h-1.28l.78.81c.134.138.131.361-.006.497-.067.066-.155.1-.242.1-.076 0-.15-.025-.213-.074l-.036-.032-.876-.91c-.38-.393-.393-1.02-.043-1.431l.048-.052.892-.913z",
    transform: "translate(-1210.000000, -345.000000) translate(1041.000000, 0.000000) translate(160.000000, 336.000000) translate(9.000000, 9.000000)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBringBack);
export default __webpack_public_path__ + "static/media/bring-back.000e631f4bf2f3d163584979c933b461.svg";
export { ForwardRef as ReactComponent };